var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoGroupsIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 61,
    viewBox: "0 0 304 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2017_9147)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M141.803 8.00404L153.757 55.5774L166.034 52.5761L154.08 5.00275L141.803 8.00404Z",
    fill: "#EAF0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.53 15.2735L166.657 55.5776L176.838 53.0888L166.711 12.7846L156.53 15.2735Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.65 6.8811H111.455V23.6293H141.65V6.8811Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.871 23.668H104V38.8092H133.871V23.668Z",
    fill: "#B4CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.396 38.8899H108.542V55.6381H144.396V38.8899Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.491 15.7529L156.094 38.2749L162.539 45.6247L188.936 23.1027L182.491 15.7529Z",
    fill: "#B4CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.404 39.7314L152.413 47.8499L160.845 47.0786L154.404 39.7314Z",
    fill: "#B4CAE4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2017_9147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9372 60.9999C37.1573 60.9999 47.8744 50.3292 47.8744 37.1661C47.8744 24.003 37.1573 13.3323 23.9372 13.3323C10.717 13.3323 0 24.003 0 37.1661C0 50.3292 10.717 60.9999 23.9372 60.9999Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9372 54.5376C33.5728 54.5376 41.384 46.7601 41.384 37.1661C41.384 27.5722 33.5728 19.7947 23.9372 19.7947C14.3016 19.7947 6.49036 27.5722 6.49036 37.1661C6.49036 46.7601 14.3016 54.5376 23.9372 54.5376Z",
    fill: "#B4CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9372 47.0702C29.4307 47.0702 33.8841 42.636 33.8841 37.1662C33.8841 31.6964 29.4307 27.2622 23.9372 27.2622C18.4436 27.2622 13.9902 31.6964 13.9902 37.1662C13.9902 42.636 18.4436 47.0702 23.9372 47.0702Z",
    fill: "#F0F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5713 15.4368L28.6593 37.1329L22.617 37.5259L22.2422 39.5269L29.2901 39.0688L54.2034 17.3727L59.0202 18.0313L66 11.9899L63.7183 11.4827L58.3894 16.0954L53.5713 15.4368Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2531 9.82565L55.5263 0.331948L55.473 0L48.5199 6.0202L48.5052 7.86317L48.4812 10.8069L23.5585 32.5123L23.4291 33.2001L22.617 37.526L28.6593 37.133L53.5713 15.4369L58.3895 16.0955L63.7183 11.4827L56.2531 9.82565Z",
    fill: "#B4CAE4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2017_9147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.109 12.4681L230.629 27.4939C228.212 33.3022 231.83 49.1572 239.015 50.4697L245.323 51.6236C252.01 52.8463 260.477 45.2017 261.343 39.4727L263.068 17.7496C263.873 12.4276 259.633 7.36466 253.422 6.22574C247.681 5.17813 242.034 7.82411 240.109 12.4681Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.033 12.483L299.513 27.5089C301.93 33.3172 298.312 49.1721 291.125 50.4861L284.826 51.6385C278.14 52.8612 269.672 45.2166 268.805 39.4891L267.066 17.766C266.261 12.4441 270.501 7.3811 276.713 6.24219C282.453 5.19457 288.1 7.83906 290.033 12.483Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.661 54.1857C295.663 54.1857 303.771 46.1063 303.771 36.1397C303.771 26.1732 295.663 18.0938 285.661 18.0938C275.659 18.0938 267.551 26.1732 267.551 36.1397C267.551 46.1063 275.659 54.1857 285.661 54.1857Z",
    fill: "#B4CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.661 48.0991C292.29 48.0991 297.663 42.7447 297.663 36.1397C297.663 29.5348 292.29 24.1804 285.661 24.1804C279.033 24.1804 273.66 29.5348 273.66 36.1397C273.66 42.7447 279.033 48.0991 285.661 48.0991Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.888 35.3331C292.691 35.3331 294.153 33.8764 294.153 32.0795C294.153 30.2826 292.691 28.8259 290.888 28.8259C289.085 28.8259 287.623 30.2826 287.623 32.0795C287.623 33.8764 289.085 35.3331 290.888 35.3331Z",
    fill: "#F0F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.11 54.1857C255.112 54.1857 263.22 46.1063 263.22 36.1397C263.22 26.1732 255.112 18.0938 245.11 18.0938C235.108 18.0938 227 26.1732 227 36.1397C227 46.1063 235.108 54.1857 245.11 54.1857Z",
    fill: "#B4CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.11 48.0991C251.738 48.0991 257.112 42.7447 257.112 36.1397C257.112 29.5348 251.738 24.1804 245.11 24.1804C238.482 24.1804 233.108 29.5348 233.108 36.1397C233.108 42.7447 238.482 48.0991 245.11 48.0991Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.337 35.3331C252.14 35.3331 253.602 33.8764 253.602 32.0795C253.602 30.2826 252.14 28.8259 250.337 28.8259C248.533 28.8259 247.071 30.2826 247.071 32.0795C247.071 33.8764 248.533 35.3331 250.337 35.3331Z",
    fill: "#F0F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.842 17.8394V17.8245H255.915V18.4336C258.748 20.4386 260.945 23.2111 262.245 26.4224H263.296V26.4389H267.894C269.194 23.2273 271.391 20.4544 274.224 18.4485V17.8394H266.842Z",
    fill: "#F0F5F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2017_9147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.938,
    height: 50.6361,
    fill: "white",
    transform: "translate(104 5.00049)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2017_9147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 61,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2017_9147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.7709,
    height: 48.186,
    fill: "white",
    transform: "translate(227 5.99976)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGroupsIcons);
export default __webpack_public_path__ + "static/media/noGroups_icons.f102b89564796943369cdf14276bed59.svg";
export { ForwardRef as ReactComponent };